import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { throttle, debounce } from "throttle-debounce";
import Select from "react-select";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import projActions from "../../../_actions/projActions";
import distOptions from "../../../_constants/distOptions";
import Table from "../../_common/Table";
import AdminProjectsDetails from "./AdminProjectsDetails";
import EditProjectModal from "./EditProjectModal";
import EditProjectUnitsModal from "./EditProjectUnitsModal";
import "./adminProjects.css";
import AlertModal from "../../_common/AlertModal";
import { PROJECT } from "../../../_constants/actionConstants";
import memoizeOne from "memoize-one";
import ProjectStatusBubble from "../../_common/ProjectStatusBubble";
import EditProjectModalV2 from "./EditProjectModalV2";

export class AdminProjects extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /** @type {SelectOption} */
      distFilter: null,
      eaFilter: "",
      proDMSOnlyFilter: false,
      // statusFilter: { value: "ALL", label: "Status: All" }, // For future use
      sortColumn: { path: "fullEA", order: "asc" },
      modalData_editProject: {
        showModal: false,
        projectId: null,
      },
      showAlert_registerProjectInProDMS: false,
      showAlert_deactivateProject: false,
      showAlert_deleteProject: false,
      showAlert_projNotAccessible: false,
      isNewProject: false,
      currPage: 1,
      pageCount: 1,
    };

    this.selectedProject = null;

    this.columns = [
      {
        path: "fullEA",
        label: "EA",
        content: (proj) => this.renderEa(proj),
        thClassName: "admin-projects-table__th--ea",
        tdClassName: "admin-projects-table__th--ea",
      },
      {
        path: "coRtePm",
        label: "Co-Rte-PM",
        thClassName: "admin-projects-table__th--co-rte-pm",
        tdClassName: "admin-projects-table__th--co-rte-pm",
      },
      {
        path: "workDescription",
        label: "Work Desc.",
        thClassName: "admin-projects-table__th--work-desc",
        tdClassName: "admin-projects-table__th--work-desc",
      },
      {
        path: "projectStatus",
        label: "Status",
        content: (proj) => <ProjectStatusBubble status={proj.projectStatus} />,
        thClassName: "admin-projects-table__th--status",
        tdClassName: "admin-projects-table__th--status",
      },
    ];

    // For future use
    // this.statusOptions = [
    //   { value: "ALL", label: "Status: All" },
    //   { value: "ADVERTISED", label: "Advertised" },
    //   { value: "PRE_CONST", label: "Pre-Const" },
    //   { value: "IN_CONST", label: "In-Const" },
    //   { value: "POST_CONST", label: "Post-Const" },
    // ];

    this.searchThrottled = throttle(250, this.handleSearch);
    this.searchDebounced = debounce(250, this.handleSearch);
  }

  async componentDidMount() {
    const { dispatch, tabId, user } = this.props;

    /** @type {ProjectFilters} */
    const filters = {
      projectId: null,
      district: user.district && user.district !== 59 ? user.district : null,
      unitId: null,
      userId: null,
      EA: "",
      proDMSProjectsOnly: false,
    };
    const pageCount = await dispatch(
      projActions.fetchAllPaged(tabId, 1, 50, true, filters)
    );
    this.setState({
      pageCount,
      distFilter: distOptions.without59.find((o) => o.value === filters.district) || null,
    });
  }

  /**
   * Refreshes project list
   */
  refreshProjList = async (clearSelectedProject = true, resetList = true) => {
    const { dispatch, tabId } = this.props;

    dispatch({ type: PROJECT.CLEAR_LIST, tabId });
    const filters = this.combineFilters();
    const pageCount = await dispatch(
      projActions.fetchAllPaged(tabId, 1, 50, resetList, filters)
    );

    if (clearSelectedProject) {
      if (this.selectedProject)
        dispatch({
          type: PROJECT.CLEAR_DETAILS,
          projectId: this.selectedProject.projectId,
        });
      this.selectedProject = null;
    } else if (this.selectedProject)
      // Refetch details
      dispatch(projActions.fetchDetails(this.selectedProject.projectId));

    this.setState({ currPage: 1, pageCount });
  };

  combineFilters = () => {
    const { distFilter, eaFilter, proDMSOnlyFilter } = this.state;
    return {
      projectId: null,
      district: distFilter ? distFilter.value : null,
      unitId: null,
      EA: eaFilter,
      proDMSProjectsOnly: proDMSOnlyFilter,
    };
  };

  handleSearch = async () => {
    const { dispatch, tabId } = this.props;
    const filters = this.combineFilters();
    const pageCount = await dispatch(
      projActions.fetchAllPaged(tabId, 1, 50, true, filters)
    );

    // There is only 1 page for search results.
    this.setState({ pageCount, currPage: 1 });
  };

  getNextPage = async () => {
    const { currPage } = this.state;
    const { dispatch, tabId } = this.props;
    const filters = this.combineFilters();
    const pageCount = await dispatch(
      projActions.fetchAllPaged(tabId, currPage + 1, 50, false, filters)
    );
    this.setState({ currPage: currPage + 1, pageCount });
  };

  handleSort = (sortColumn) => this.setState({ sortColumn });

  handleChange_eaFilter = (e) =>
    this.setState({ eaFilter: e.target.value }, async () => {
      const { eaFilter } = this.state;
      const { dispatch, tabId } = this.props;
      let pageCount = 1;

      if (!eaFilter) {
        const filters = this.combineFilters();
        pageCount = await dispatch(
          projActions.fetchAllPaged(tabId, 1, 50, true, filters)
        );
        this.setState({ currPage: 1, pageCount });
      } else if (eaFilter.length < 3) this.searchThrottled();
      else this.searchDebounced();
    });

  handleChange_selectFilter = (fieldName) => (selectedOption) => {
    const { dispatch, tabId } = this.props;
    if (fieldName === "distFilter") {
      this.setState(
        {
          distFilter: selectedOption || null,
          eaFilter: "",
        },
        async () => {
          const filters = this.combineFilters();
          const pageCount = await dispatch(
            projActions.fetchAllPaged(tabId, 1, 50, true, filters)
          );
          // Changing filters clear out the current selectedProject
          if (this.selectedProject) {
            dispatch({
              type: PROJECT.CLEAR_DETAILS,
              projectId: this.selectedProject.projectId,
            });
            this.selectedProject = null;
          }
          this.setState({ currPage: 1, pageCount });
        }
      );
    }
  };

  handleClick_proDMSOnlyFilter = (e) => {
    e.preventDefault();
    this.setState({ proDMSOnlyFilter: !this.state.proDMSOnlyFilter }, async () => {
      const { dispatch, tabId } = this.props;
      const filters = this.combineFilters();
      const pageCount = await dispatch(
        projActions.fetchAllPaged(tabId, 1, 50, true, filters)
      );

      if (this.selectedProject)
        dispatch({
          type: PROJECT.CLEAR_DETAILS,
          projectId: this.selectedProject.projectId,
        });
      this.selectedProject = null;

      this.setState({ currPage: 1, pageCount });
    });
  };

  handleAlert_addToProDMS = (alertAction) => async (e) => {
    e.preventDefault();
    const { tabId, dispatch } = this.props;
    if (alertAction === "accept") {
      // Activation must first be completed before moving on to next fetch
      await dispatch(projActions.activate(this.selectedProject.projectId));

      // Re-fetch fresh list for all other ProjectList tabs that are open
      dispatch(projActions.refetchAllOpenProjectLists(this.selectedProject.district));

      // Re-fetch fresh list. Also clear the list cache and selected project.
      dispatch({ type: PROJECT.CLEAR_LIST, tabId });
      if (this.selectedProject)
        dispatch({
          type: PROJECT.CLEAR_DETAILS,
          projectId: this.selectedProject.projectId,
        });
      const filters = this.combineFilters();
      const pageCount = await dispatch(
        projActions.fetchAllPaged(tabId, 1, 50, true, filters)
      );
      this.setState({ currPage: 1, pageCount });
    }
    this.toggleAlert_registerProjectInProDMS();
  };

  handleAlert_deactivateProject = (alertAction) => async (e) => {
    e.preventDefault();
    const { tabId, dispatch } = this.props;
    if (alertAction === "accept") {
      await dispatch(projActions.deactivate(this.selectedProject.projectId));

      // Re-fetch fresh list for all other ProjectList tabs that are open
      dispatch(projActions.refetchAllOpenProjectLists(this.selectedProject.district));

      // Re-fetch fresh list. Also clear the list cache and selected project.
      dispatch({ type: PROJECT.CLEAR_LIST, tabId });
      if (this.selectedProject)
        dispatch({
          type: PROJECT.CLEAR_DETAILS,
          projectId: this.selectedProject.projectId,
        });
      const filters = this.combineFilters();
      const pageCount = await dispatch(
        projActions.fetchAllPaged(tabId, 1, 50, true, filters)
      );
      this.setState({ currPage: 1, pageCount });
    }
    this.toggleAlert_deactivateProject();
  };

  handleAlert_deleteProject = (alertAction) => async (e) => {
    e.preventDefault();
    const { tabId, dispatch } = this.props;
    if (alertAction === "accept") {
      const deleted = await dispatch(projActions.deleteProject(this.selectedProject.projectId));
      if (deleted) {
        dispatch(projActions.refetchAllOpenProjectLists(this.selectedProject.district));
        dispatch({ type: PROJECT.CLEAR_LIST, tabId });
        dispatch({
          type: PROJECT.CLEAR_DETAILS,
          projectId: this.selectedProject.projectId,
        });
        this.selectedProject = null;
        const filters = this.combineFilters();
        const pageCount = await dispatch(
          projActions.fetchAllPaged(tabId, 1, 50, true, filters)
        );
        this.setState({ currPage: 1, pageCount });
      }
    }
    this.toggleAlert_deleteProject();
  };

  /**
   * Click event handler for the project table. Sets the current
   * selectedProject.
   * @param {ProjectListDto} proj
   */
  handleClick_projListTr = async (proj) => {
    const { dispatch } = this.props;

    // Set the current selected project
    this.selectedProject = proj;

    // Do not await fetchDetails; show selectedProject in the table first, then
    // show spinner until details are fetched and available in redux store.
    dispatch(projActions.fetchDetails(proj.projectId));

    if (!proj.isProDMSProject) this.toggleAlert_registerProjectInProDMS();
  };

  handleClick_addProject = (e) => {
    e.preventDefault();
    this.setState({ modalData_editProject: { showModal: true, projectId: null } });
    // this.setState({ isNewProject: true }, this.toggleEditProjectModal);
  };

  handleClick_editProjectInfo = (e) => {
    e.preventDefault();
    if (!this.selectedProject) return;
    this.setState({
      modalData_editProject: {
        showModal: true,
        projectId: this.selectedProject.projectId,
      },
    });
    // this.setState({ isNewProject: false }, this.toggleEditProjectModal);
  };

  toggleEditProjectModal = () =>
    this.setState({
      modalData_editProject: {
        ...this.state.modalData_editProject,
        showModal: !this.state.modalData_editProject.showModal,
      },
    });

  toggleAlert_registerProjectInProDMS = () =>
    this.setState({
      showAlert_registerProjectInProDMS: !this.state.showAlert_registerProjectInProDMS,
    });
  toggleAlert_deactivateProject = () =>
    this.setState({
      showAlert_deactivateProject: !this.state.showAlert_deactivateProject,
    });
  toggleAlert_deleteProject = () =>
    this.setState({
      showAlert_deleteProject: !this.state.showAlert_deleteProject,
    });
  toggleAlert_projNotAccessible = () =>
    this.setState({
      showAlert_projNotAccessible: !this.state.showAlert_projNotAccessible,
    });

  renderEa = (proj) => {
    return proj.isProDMSProject ? (
      <div className="d-flex flex-row flex-wrap">
        <div className="mr-2">
          <b>{proj.fullEA}</b>
          <FontAwesomeIcon icon="check-circle" className="fa-fw ml-1" />
        </div>
      </div>
    ) : (
      <span className="text-muted">{proj.fullEA}</span>
    );
  };

  renderTableFilters = () => {
    const { distFilter, eaFilter, proDMSOnlyFilter } = this.state;
    return (
      <div className="d-flex flex-row flex-wrap w-100 mb-1 admin-filter-group">
        <div className="admin-filter-item admin-filter-item__select--proj-dist mr-2">
          <Select
            name="distFilter"
            id="distFilter"
            className="align-middle w-100 px-0"
            value={distFilter}
            options={distOptions.without59}
            onChange={this.handleChange_selectFilter("distFilter")}
            placeholder="Dist"
            isSearchable={false}
            isClearable
          />
        </div>
        <div className="admin-filter-item admin-filter-item__input admin-filter-item__input--proj-ea pr-2 flex-grow-1">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text bg-lightgray">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="eaFilter"
              id="eaFilter"
              className="form-control"
              value={eaFilter}
              onChange={this.handleChange_eaFilter}
              placeholder="EA (ex. 1A1234)"
            />
          </div>
        </div>
        <div className="admin-filter-item admin-filter-item__btn--prodms">
          <Button
            name="proDMSOnlyFilter"
            id="proDMSOnlyFilter"
            color="dark"
            className=""
            outline
            onClick={this.handleClick_proDMSOnlyFilter}
            active={proDMSOnlyFilter}
          >
            ProDMS Projects Only
          </Button>
        </div>
      </div>
    );
  };

  render() {
    const {
      sortColumn,
      showAlert_registerProjectInProDMS,
      showAlert_deactivateProject,
      showAlert_deleteProject,
      showAlert_projNotAccessible,
      modalData_editProject,
      currPage,
      pageCount,
    } = this.state;
    const { projList, permissions } = this.props;

    return (
      <React.Fragment>
        <h2 className="mb-1">Projects</h2>
        <hr className="mt-0 mb-2" />
        <div className="d-flex flex-row w-100">
          <div className="admin-list pr-1">
            <div className="form-inline mb-2">
              <button
                type="button"
                name="syncProjData"
                id="syncProjData"
                className="btn btn-secondary mr-2"
                onClick={this.handleClick_syncProjData}
                disabled
              >
                <FontAwesomeIcon icon="sync-alt" className="fa-fw mr-1" />
                Refresh
              </button>
              <button
                type="button"
                name="addProject"
                id="addProject"
                className="btn btn-info mr-2"
                onClick={this.handleClick_addProject}
              >
                <FontAwesomeIcon icon="folder-plus" className="fa-fw mr-1" />
                New...
              </button>
            </div>
            <div className="row">
              <div className="col">{this.renderTableFilters()}</div>
            </div>
            <div className="d-flex flex-row w-100 mb-1">
              <div className="alert alert-info p-2 w-100 mb-0">
                <h6>
                  <FontAwesomeIcon icon="info-circle" className="fa-fw mr-2" />
                  Adding Projects to ProDMS
                </h6>
                <ul className="mb-0 pl-4">
                  <li>
                    Below list shows all projects currently in CAS, and any informal bid
                    projects that were added manually. To register a new project, first
                    look up the EA then select to continue. The{" "}
                    <FontAwesomeIcon icon="check-circle" className="fa-fw mx-0" /> icon
                    next to EA indicates the project is registered in ProDMS.
                  </li>
                  <li>
                    Any informal bid projects such as Minor B or Director's Order projects
                    need to be added manually, by clicking on the "New..." button above.
                  </li>
                </ul>
              </div>
            </div>
            <div className="admin-list__table--wrapper border">
              <Table
                className="table table-sm table-hover admin-list__table"
                data={projList || []}
                idPropName="projectId"
                selectedItemId={this.selectedProject && this.selectedProject.projectId}
                columns={this.columns}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                handleClick_tr={this.handleClick_projListTr}
                isPaginated={true}
                currPage={currPage}
                pageCount={pageCount}
                getNextPage={this.getNextPage}
              />
            </div>
          </div>
          <div className="admin-details">
            <div className="card">
              <div className="card-header bg-lightgray">Selected Project</div>
              <div className="card-body">
                <AdminProjectsDetails
                  projectId={this.selectedProject && this.selectedProject.projectId}
                  showButtons={true}
                  showUnitsAndStaff={true}
                  permissions={permissions}
                  handleClick_editProjectInfo={this.handleClick_editProjectInfo}
                  toggleAlert_registerProjectInProDMS={
                    this.toggleAlert_registerProjectInProDMS
                  }
                  toggleAlert_deactivateProject={this.toggleAlert_deactivateProject}
                  toggleAlert_deleteProject={this.toggleAlert_deleteProject}
                />
              </div>
            </div>
          </div>
        </div>
        {modalData_editProject.showModal && (
          <EditProjectModalV2
            projectId={modalData_editProject.projectId}
            showModal={modalData_editProject.showModal}
            toggleModal={this.toggleEditProjectModal}
            refreshProjList={this.refreshProjList}
          />
        )}
        {/* {showEditProjectModal && (
          <EditProjectModal
            isNewProject={isNewProject}
            projectId={isNewProject ? null : this.selectedProject.projectId}
            showEditProjectModal={showEditProjectModal}
            toggleEditProjectModal={this.toggleEditProjectModal}
            refreshProjList={this.refreshProjList}
          />
        )} */}
        {showAlert_registerProjectInProDMS && (
          <AlertModal
            alertTitle="Add to ProDMS"
            alertTitleClass="bg-info text-white"
            alertTitleIcon="question-circle"
            alertText={"Add this project for use in ProDMS?"}
            acceptCaption={"Yes"}
            acceptClass={"primary"}
            provideReject={true}
            rejectCaption={"No"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_addToProDMS}
            toggleAlertModal={this.toggleAlert_registerProjectInProDMS}
            showAlertModal={showAlert_registerProjectInProDMS}
          />
        )}
        {showAlert_deactivateProject && (
          <AlertModal
            alertTitle="Deactivate Project"
            alertTitleClass="bg-danger text-white"
            alertTitleIcon="exclamation-triangle"
            alertText={
              `Deactivate this project for use in ProDMS?\n` +
              `Users will no longer be able to open this project's dashboard or submit ` +
              `daily reports against it. Existing data (ADRs, staff assignments, etc.) is ` +
              `not deleted, and the project can be re-activated later.`
            }
            acceptCaption={"Yes, Deactivate"}
            acceptClass={"danger"}
            provideReject={true}
            rejectCaption={"Cancel"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_deactivateProject}
            toggleAlertModal={this.toggleAlert_deactivateProject}
            showAlertModal={showAlert_deactivateProject}
          />
        )}
        {showAlert_deleteProject && (
          <AlertModal
            alertTitle="Delete Project"
            alertTitleClass="bg-danger text-white"
            alertTitleIcon="exclamation-triangle"
            alertText={
              `Permanently delete this project?\n` +
              `This cannot be undone. The project can only be deleted if it has no Daily ` +
              `Reports, Bid Items, Locations, CCOs, Pending Issues, RFIs, Overtime, or ` +
              `Pending Labor records - if any exist, this action will be rejected.`
            }
            acceptCaption={"Yes, Delete"}
            acceptClass={"danger"}
            provideReject={true}
            rejectCaption={"Cancel"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_deleteProject}
            toggleAlertModal={this.toggleAlert_deleteProject}
            showAlertModal={showAlert_deleteProject}
          />
        )}
        {showAlert_projNotAccessible && (
          <AlertModal
            alertTitle="Project Not Accessible"
            alertTitleClass="bg-warning"
            alertTitleIcon="exclamation-triangle"
            alertText={
              `Access to this project is closed in the current environment.\n` +
              `If this project is included in your district's ProDMS Implementation Program, ` +
              `it can be accessed only from https://prodms.dot.ca.gov.\n` +
              `Otherwise, use https://dmsbeta2.azurewebsites.net to access the project.\n` +
              `Please contact your district's ProDMS Administrator for more info.`
            }
            acceptCaption={"OK"}
            acceptClass={"secondary"}
            provideReject={false}
            handleAlertAction={this.toggleAlert_projNotAccessible}
            toggleAlertModal={this.toggleAlert_projNotAccessible}
            showAlertModal={showAlert_projNotAccessible}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  fetching: state.projects.fetching,
  appSettings: state.appSettings,
  user: state.authentication.user,
  projList: state.projects.openProjectLists[ownProps.tabId] || [],
});

export default connect(mapStateToProps)(AdminProjects);
